import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, Loader2, ArrowLeft, RefreshCw } from 'lucide-react';
import api from '../lib/api';

export default function PaymentFailure() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const merchantOid = searchParams.get('merchant_oid');
  const [orderStatus, setOrderStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!merchantOid) {
      navigate('/credits');
      return;
    }

    const checkStatus = async () => {
      try {
        const response = await api.get(`/paytr/order-status/${merchantOid}`);
        setOrderStatus(response.data);
      } catch (error) {
        console.error('Order status check error:', error);
      } finally {
        setLoading(false);
      }
    };

    checkStatus();
  }, [merchantOid, navigate]);

  if (!merchantOid) {
    return null;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <div className="max-w-2xl mx-auto px-4 py-16">
        <Card>
          <CardHeader>
            <div className="flex flex-col items-center text-center">
              <XCircle className="h-16 w-16 text-red-600 mb-4" />
              <CardTitle className="text-2xl text-red-600">Ödeme Başarısız</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="space-y-4">
            {loading ? (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
              </div>
            ) : (
              <>
                <div className="bg-red-50 p-4 rounded-lg">
                  <p className="text-sm text-slate-700">
                    <strong>Sipariş No:</strong> {orderStatus?.merchant_oid || merchantOid}
                  </p>
                  {orderStatus && (
                    <>
                      <p className="text-sm text-slate-700">
                        <strong>Kredi Miktarı:</strong> {orderStatus.credits} kredi
                      </p>
                      <p className="text-sm text-slate-700">
                        <strong>Tutar:</strong> {orderStatus.amount_tl} ₺
                      </p>
                    </>
                  )}
                  <p className="text-sm text-slate-700 mt-2">
                    <strong>Durum:</strong> <span className="text-red-600 font-semibold">Başarısız</span>
                  </p>
                </div>

                <div className="p-4 bg-yellow-50 rounded-lg">
                  <p className="text-sm text-slate-700 font-semibold mb-2">
                    Ödemeniz işlenemedi. Olası sebepler:
                  </p>
                  <ul className="text-sm text-slate-600 space-y-1">
                    <li>• Kart limitiniz yetersiz olabilir</li>
                    <li>• Kart bilgileri hatalı girilmiş olabilir</li>
                    <li>• 3D Secure doğrulaması başarısız olabilir</li>
                    <li>• Teknik bir sorun yaşanmış olabilir</li>
                  </ul>
                </div>

                <div className="p-4 bg-blue-50 rounded-lg">
                  <p className="text-sm text-slate-700">
                    💡 <strong>Öneriler:</strong>
                  </p>
                  <ul className="text-sm text-slate-600 mt-2 space-y-1">
                    <li>• Kart bilgilerinizi kontrol ederek tekrar deneyin</li>
                    <li>• Farklı bir ödeme yöntemi kullanmayı deneyin</li>
                    <li>• Sorun devam ederse destek ekibimizle iletişime geçin</li>
                  </ul>
                </div>

                <div className="flex gap-3 pt-4">
                  <Button 
                    onClick={() => navigate('/credits')}
                    className="flex-1"
                  >
                    <RefreshCw className="mr-2 h-4 w-4" />
                    Tekrar Dene
                  </Button>
                  <Button 
                    onClick={() => navigate('/dashboard')}
                    variant="outline"
                    className="flex-1"
                  >
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Dashboard'a Dön
                  </Button>
                </div>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
